/**
 * Problem types come from API with Polish `name` / `description`.
 * Map known strings to i18n keys under `problemTypes.names.*` and `problemTypes.descriptions.*`.
 * Unknown admin-defined types fall back to the original string.
 */

const NAME_KEYS: Record<string, string> = {
  'Awaria linii': 'lineFailure',
  'Brak barwnika': 'noDye',
  'Brak materialu': 'noMaterial',
  'Brak materiału': 'noMaterial',
  'Brak szpul': 'noSpools',
  Czyszczenie: 'cleaning',
  'Jestem idiotą, nie mogę tego zrobić.': 'cannotDoJoke',
  'Problem z barwnikom': 'dyeIssue',
};

const DESC_KEYS: Record<string, string> = {
  'przykleja się do ślimaka': 'sticksToAuger',
};

export function translateProblemTypeName(name: string, t: (key: string) => string): string {
  const k = NAME_KEYS[name];
  return k ? t(`problemTypes.names.${k}`) : name;
}

export function translateProblemTypeDescription(
  description: string | null | undefined,
  t: (key: string) => string
): string {
  if (description == null || description === '') return '';
  const k = DESC_KEYS[description];
  return k ? t(`problemTypes.descriptions.${k}`) : description;
}

/**
 * Detect the "Brak barwnika" (no dye) problem.
 * Used to highlight only the "Barwnik" column cell instead of the whole row.
 * Matches either the dedicated `problem_bb` status or a "Brak barwnika" note.
 */
export function isNoDyeProblem(
  status: string | null | undefined,
  note: string | null | undefined
): boolean {
  return status === 'problem_bb' || (note ?? '').trim().toLowerCase() === 'brak barwnika';
}
